import { FixedButtonContainer } from "components/common/buttons/FixedButtons";
import { TYPO } from "styles/Typo";
import { useRouter } from "next/router";
import useDiscussAlarm from "utils/hooks/DiscussAlarm";
import CustomToast from "components/atoms/CustomToast";
import { useState } from "react";
import { useTrackedNavigation } from "lib/analytics/react/hooks";

function BriefingAlarmButton({ isMobile }: { isMobile: boolean }) {
  const router = useRouter();
  const from = router.query?.from;
  const [errorToast, setErrorToast] = useState(false);
  const { navigateWithTracking } = useTrackedNavigation();
  // 토론 알림 관리
  const {
    DebateAlarmOnStatus,
    isValid,
    debateAlarmRegister,
    alarmRegisterToast,
    setAlarmRegisterToast,
  } = useDiscussAlarm();
  return (
    <>
      <FixedButtonContainer isMobile={isMobile}>
        <div className="flex flex-col gap-[10px] items-center justify-center">
          <button
            className="bg-gray90 rounded-[14px] flex gap-1 items-center px-[18px] py-[13px] grow flex-1  justify-center cursor-pointer w-full"
            onClick={() => {
              if (DebateAlarmOnStatus?.isNewAgendaAlarmOn) {
                setErrorToast(true);
                return;
              }
              debateAlarmRegister(true, "NEW", "briefing_final");
            }}
            data-gtm-id="briefing-alarm-button"
          >
            <p className={`${TYPO.TYPO5_MD} text-white`}>문자로 알림 받기</p>
          </button>
          <button
            className={`bg-gray5  rounded-[14px] flex gap-1 items-center px-[18px] py-[13px] grow flex-1  justify-center w-full cursor-pointer`}
            onClick={() => {
              navigateWithTracking({
                href: from ? "back" : "/?type=feed",
                itemspec: {
                  kind: "section_nav",
                  section_id: "briefing_final",
                  nav_key: "briefing_navbtn_close",
                },
              });
              // if (from) {
              //   router.back();
              // //   return;
              // // }
              // router.push("/?type=feed");
            }}
          >
            <p className={`${TYPO.TYPO5_MD} text-gray80`}>닫기</p>
          </button>
        </div>
      </FixedButtonContainer>
      <CustomToast
        message="이제 문자로 새 글 알림을 받아요"
        isVisible={alarmRegisterToast}
        onClose={() => {
          setAlarmRegisterToast(false);
        }}
        isSuccess={true}
        width={260}
        successIconFill={"#34BB7A"}
        duration={3000}
        customAnimation={"bottom-toast-briefing"}
      />
      <CustomToast
        message="이미 알림을 신청했어요"
        isVisible={errorToast}
        onClose={() => {
          setErrorToast(false);
        }}
        isSuccess={false}
        width={260}
        successIconFill={"#34BB7A"}
        duration={3000}
        customAnimation={"bottom-toast-briefing"}
      />
    </>
  );
}

export default BriefingAlarmButton;
